import React from 'react';
import classNames from 'classnames';
import omit from '../util/omit';
import Element from './Element';
import ConfigContext from './configContext';

const SkeletonButton = props => {
  const renderSkeletonButton = ({ getPrefixCls }) => {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const otherProps = omit(props, ['prefixCls']);
    const cls = classNames(
      prefixCls,
      `${prefixCls}-element`,
      { [`${prefixCls}-active`]: active },
      className,
    );
    return (
      <div className={cls}>
        <Element prefixCls={`${prefixCls}-button`} {...otherProps} />
      </div>
    );
  };
  return <ConfigContext.Consumer>{renderSkeletonButton}</ConfigContext.Consumer>;
};
SkeletonButton.defaultProps = {
  size: 'default',
};
export default SkeletonButton;



// WEBPACK FOOTER //
// ./src/skeleton/Button.jsx